import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { useField } from 'react-final-form';
import AddressQualification from '../AddressQualification.js';
import { Label, LabelText, AddressSelect as AddressSelect$2, ErrorText } from '../Form.styles.js';

var _excluded = ["name", "type", "label", "smartyStreetsWebsiteKey", "placeholderText", "validations"];
var AddressSelect = function AddressSelect(_ref) {
  var name = _ref.name;
    _ref.type;
    var label = _ref.label,
    smartyStreetsWebsiteKey = _ref.smartyStreetsWebsiteKey,
    _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? null : _ref$placeholderText,
    _ref$validations = _ref.validations,
    validations = _ref$validations === void 0 ? null : _ref$validations,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(new AddressQualification({
      smartyStreetsWebsiteKey: smartyStreetsWebsiteKey
    })),
    _useState2 = _slicedToArray(_useState, 1),
    addressQual = _useState2[0];
  var _useField = useField(name, {
      validate: validations
    }),
    input = _useField.input,
    meta = _useField.meta;
  return /*#__PURE__*/React__default.createElement(Label, {
    gridArea: name
  }, /*#__PURE__*/React__default.createElement(LabelText, {
    className: "label input-label"
  }, label), /*#__PURE__*/React__default.createElement(AddressSelect$2, _extends({}, input, rest, {
    cacheOptions: true,
    defaultOptions: true,
    loadOptions: function loadOptions(inputValue) {
      return addressQual.autofillSuggestions(inputValue)["catch"](function (err) {
        return console.error(err);
      });
    } // eslint-disable-line
    ,
    placeholder: placeholderText,
    isClearable: true,
    isTouchedAndValid: Boolean(meta.touched && !meta.error),
    hasError: Boolean(meta.touched && meta.error),
    "aria-invalid": Boolean(meta.touched && meta.error),
    styles: {
      // Fixes the overlapping problem of the component
      // This method comes straight from their docs
      menu: function menu(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          zIndex: 26
        });
      }
    }
  })), meta.error && meta.touched && /*#__PURE__*/React__default.createElement(ErrorText, {
    className: "error-text"
  }, meta.error));
};
var AddressSelect$1 = AddressSelect;

export { AddressSelect$1 as default };
//# sourceMappingURL=AddressSelect.js.map
